import {FETCH_REFERRAL_ID,EDIT_REFERRAL_ID,FETCH_REFERRAL_ID_SUCCESS,FETCH_REFERRAL_ID_FAILED,FETCH_REFERRAL_LIST_FAILED,CLEAR_REFERRAL_SUB_LEVELS} from "../store/types"
import {firebase} from "../config/configureFirebase";
import store from "../store/store";
import { onValue, push, off, get, remove, child } from "firebase/database";
import { pushAuthHeaders, pushEndpointHost } from "../other/NotificationFunctions";

/** uid cuya lista nivel 1 ya está cargada; se descarta una respuesta que llegue tras cambiar de sesión */
let listReferralLoadedFor = null;
let listReferralRequestSeq = 0;

const sortByNewestAndLimit = (arr, limit = 200) => {
    const sorted = [...(arr || [])].sort((a, b) => {
        const at = Number(a?.createdAt || 0);
        const bt = Number(b?.createdAt || 0);
        return bt - at;
    });
    return sorted.slice(0, limit);
};

/** Lista nivel 1: antes 200 cortaba referidos antiguos que ya no aparecían */
const LIST_REFERRAL_LEVEL1_MAX = 2000;

export const unsubscribeReferralListListener = () => {
    listReferralLoadedFor = null;
    listReferralRequestSeq++;
};

/** Hijos directos y nombres de patrocinador se piden al servidor: /users no es legible entre usuarios. */
const callReferralNetwork = async (body) => {
    const response = await fetch(`${pushEndpointHost()}/referral_network`, {
        method: 'POST',
        headers: await pushAuthHeaders(),
        body: JSON.stringify(body),
    });
    const json = await response.json().catch(() => null);
    if (!response.ok || !json || json.error) {
        throw new Error((json && json.error) || `referral_network ${response.status}`);
    }
    return json;
};

const fetchReferralChildren = async (parentUids) =>
    (await callReferralNetwork({ action: 'children', parents: parentUids })).rows || [];


export const fetchusedreferral = ()=>(dispatch)=>{
    const {
        usedreferralRef
    } = firebase;


    dispatch ({
        type:FETCH_REFERRAL_ID,
        payload:null
    })
    onValue (usedreferralRef,snapshot=>{
        if (snapshot.val()) {
            const data = snapshot.val();
            const arr = Object.keys(data).map(i => {
              data[i].id = i
              return data[i]
            });
            dispatch({
              type: FETCH_REFERRAL_ID_SUCCESS,
              payload: arr.reverse()
            });
          } else {
            dispatch({
              type: FETCH_REFERRAL_ID_FAILED,
              payload: "No SOS available."
            });
          }
        // if(snapshot.val()){
        //     const data = snapshot.val();
        //     const arr = Object.keys(data).map(i=>{
        //         data[i].id = i;
        //         return data[i]
        //     });
        //     dispatch({
        //         type:FETCH_REFERRAL_ID_SUCCESS,
        //         payload:arr.reverse()
        //     });
        // }
        // else {
        //     dispatch({
        //         type:FETCH_REFERRAL_ID_FAILED,
        //         payload:"No referral id used"
        //     })
        // }
    })



}

export const editreferral = (users,method)=>(dispatch)=>{
    const {
        usedreferralRef,
    } = firebase;

    dispatch({
        type:EDIT_REFERRAL_ID,
        payload:{method,users}
    });
    if(method ==='Add'){
        push(usedreferralRef,users)
        
    } else if (method === 'Delete' && users) {
        // Limpieza al borrar conductor (también lo hace Cloud Function userDelete).
        const email = users.email ? String(users.email).trim().toLowerCase() : '';
        const phone = users.phone || users.mobile
            ? String(users.phone || users.mobile).trim()
            : '';
        const uid = users.uid ? String(users.uid).trim() : '';
        get(usedreferralRef).then((snap) => {
            const data = snap.val();
            if (!data) return;
            Object.keys(data).forEach((key) => {
                const row = data[key] || {};
                const rowEmail = row.email ? String(row.email).trim().toLowerCase() : '';
                const rowPhone = row.phone || row.mobile
                    ? String(row.phone || row.mobile).trim()
                    : '';
                const rowUid = row.uid ? String(row.uid).trim() : '';
                if (
                    (uid && rowUid && rowUid === uid) ||
                    (email && rowEmail && rowEmail === email) ||
                    (phone && rowPhone && rowPhone === phone)
                ) {
                    remove(child(usedreferralRef, key)).catch(() => { /* ignore */ });
                }
            });
        }).catch(() => { /* ignore */ });
    }
}

/** Limpia listRefer2 / listRefer3 sin tocar nivel 1 ni patrocinador */
export const clearReferralSubLevels = () => ({
    type: CLEAR_REFERRAL_SUB_LEVELS
});

/**
 * Lista nivel 1 del viewer: signupViaReferral === uid del conductor
 * o === su referralId (legacy: código en vez de UID; varios formatos de casing).
 */
export const listReferral = (uid, forceRefresh = false) => async (dispatch) => {
    if (!uid) {
        return;
    }
    if (!forceRefresh && listReferralLoadedFor === uid) {
        return;
    }
    const seq = ++listReferralRequestSeq;

    dispatch({
        type: 'FETCH_REFERRAL_LIST',
        payload: null
    });

    try {
        const rows = await fetchReferralChildren([uid]);
        if (seq !== listReferralRequestSeq) return;
        listReferralLoadedFor = uid;
        if (!rows.length) {
            dispatch({
                type: FETCH_REFERRAL_LIST_FAILED,
                payload: []
            });
            return;
        }
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS',
            payload: sortByNewestAndLimit(rows, LIST_REFERRAL_LEVEL1_MAX)
        });
    } catch (err) {
        if (seq !== listReferralRequestSeq) return;
        console.warn('[listReferral]', err?.message || err);
        dispatch({
            type: FETCH_REFERRAL_LIST_FAILED,
            payload: []
        });
    }
};

/** UID válido de patrocinador (no vacío ni placeholder " ") */
export const normalizeSponsorUid = (signupViaReferral) => {
    if (signupViaReferral == null) return null;
    const s = String(signupViaReferral).trim();
    if (!s || s === '') return null;
    return s;
};

/**
 * UID de la cuenta "plataforma / código master" (ej. ventas@… con firstName Master).
 * Configurar en Realtime Database: settings/masterReferrerUid = "<firebase_uid>"
 */
export const getMasterReferrerUidFromSettings = () => {
    try {
        const v = store.getState()?.settingsdata?.settings?.masterReferrerUid;
        if (v == null) return null;
        const t = String(v).trim();
        return t || null;
    } catch (e) {
        return null;
    }
};

/** true si el usuario fue referido por la cuenta master configurada en settings */
export const isPlatformMasterReferrerSignup = (signupViaReferral) => {
    const master = getMasterReferrerUidFromSettings();
    if (!master) return false;
    const s = normalizeSponsorUid(signupViaReferral);
    return !!s && s === master;
};

const fetchSponsorNames = async (keys) =>
    (await callReferralNetwork({ action: 'names', keys })).names || {};

/**
 * Nombre legible del patrocinador: por UID o por código referralId (legacy).
 * Devuelve null si no existe → la UI debe mostrar CODIGO MASTER.
 */
export const resolveReferrerDisplayName = async (signupKey) => {
    const s = String(signupKey || '').trim();
    if (!s) return null;
    const masterUid = getMasterReferrerUidFromSettings();
    if (masterUid && s === masterUid) {
        return null;
    }
    try {
        const names = await fetchSponsorNames([s]);
        return names[s] || null;
    } catch (err) {
        return null;
    }
};

/** Resuelve nombres para varios UIDs / códigos (tabla de referidos) */
export const batchFetchSponsorNames = async (uids) => {
    const uniq = [...new Set((uids || []).map(normalizeSponsorUid).filter(Boolean))];
    if (!uniq.length) return {};
    const names = await fetchSponsorNames(uniq);
    const map = {};
    uniq.forEach((key) => {
        map[key] = names[key] || '';
    });
    return map;
};

// Obtiene el nombre del sponsor para mostrarlo en lugar del UID
export const fetchSponsorName = (sponsorId) => async (dispatch) => {
    const uid = normalizeSponsorUid(sponsorId);
    if (!uid) {
        dispatch({ type: 'SET_SPONSOR', payload: '' });
        return;
    }
    try {
        const displayName = await resolveReferrerDisplayName(uid);
        dispatch({ type: 'SET_SPONSOR', payload: displayName || '' });
    } catch (err) {
        dispatch({ type: 'SET_SPONSOR', payload: '' });
    }
};

export const clearSponsorDisplay = () => ({
    type: 'SET_SPONSOR',
    payload: ''
});

export const sponsor = (sponsorId) => (dispatch) => {
    dispatch({
        type: 'SET_SPONSOR',
        payload: sponsorId
    });
};

// OPTIMIZACIÓN: Función para limpiar listeners de referidos
export const stopFetchReferrals = (uid) => (dispatch) => {
    const { usedreferralRef } = firebase;

    dispatch({
        type: 'STOP_FETCH_REFERRALS',
        payload: null
    });

    unsubscribeReferralListListener();
    off(usedreferralRef);
};

export const listReferral2 = (referralList) => (dispatch) => {
    dispatch({
        type: 'SET_REFERRAL_LEVEL_2',
        payload: referralList
    });
};

export const listReferral3 = (referralList) => (dispatch) => {
    dispatch({
        type: 'SET_REFERRAL_LEVEL_3',
        payload: referralList
    });
};

export const lista_id = (id) => (dispatch) => {
    dispatch({
        type: 'SET_REFERRAL_ID_LEVEL_1',
        payload: id
    });
};

export const lista_id2 = (id) => (dispatch) => {
    dispatch({
        type: 'SET_REFERRAL_ID_LEVEL_2',
        payload: id
    });
};

/**
 * Nivel 2 (o subárbol): une los hijos directos de varios padres (sin duplicar por id).
 * Devuelve una promesa para poder encadenar niveles (botones Level 2/3 en web).
 */
export const getAggregatedReferralsLevel2 = (parentUids) => async (dispatch) => {
    const uids = [...new Set((parentUids || []).filter(Boolean))];
    dispatch({
        type: 'FETCH_REFERRAL_LIST2_LOADING',
        payload: true
    });
    if (!uids.length) {
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS2',
            payload: []
        });
        return;
    }
    try {
        const merged = await fetchReferralChildren(uids);
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS2',
            payload: sortByNewestAndLimit(merged, 200)
        });
    } catch (err) {
        console.error('getAggregatedReferralsLevel2', err);
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS2',
            payload: []
        });
    }
};

/** Igual que nivel 2 pero para hijos de usuarios de nivel 2 */
export const getAggregatedReferralsLevel3 = (parentUids) => async (dispatch) => {
    const uids = [...new Set((parentUids || []).filter(Boolean))];
    dispatch({
        type: 'FETCH_REFERRAL_LIST3_LOADING',
        payload: true
    });
    if (!uids.length) {
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS3',
            payload: []
        });
        return;
    }
    try {
        const merged = await fetchReferralChildren(uids);
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS3',
            payload: sortByNewestAndLimit(merged, 200)
        });
    } catch (err) {
        console.error('getAggregatedReferralsLevel3', err);
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS3',
            payload: []
        });
    }
};

/**
 * Vista completa nivel 3: recalcula nivel 2 desde todo el nivel 1 y luego nivel 3.
 * Así el botón "Level 3" coincide con "todos los referidos de 3.er grado", no solo un drill.
 */
export const loadAggregatedReferralsLevel3 = () => async (dispatch, getState) => {
    const st = getState().usedreferralid || {};
    const l1 = st.listRefer;
    if (!l1?.length) {
        dispatch({
            type: 'FETCH_REFERRAL_LIST3_LOADING',
            payload: true
        });
        dispatch({
            type: 'FETCH_REFERRAL_LIST_SUCCESS3',
            payload: []
        });
        return;
    }
    await dispatch(getAggregatedReferralsLevel2(l1.map((r) => r.id)));
    const l2 = getState().usedreferralid?.listRefer2 || [];
    await dispatch(getAggregatedReferralsLevel3(l2.map((r) => r.id)));
};

// Un solo padre (clic en fila): mismo pipeline agregado con un uid
export const getUserReferralsLevel2 = (uid) => {
    if (!uid) {
        return (dispatch) => {
            dispatch({ type: 'FETCH_REFERRAL_LIST2_LOADING', payload: true });
            dispatch({ type: 'FETCH_REFERRAL_LIST_SUCCESS2', payload: [] });
        };
    }
    return getAggregatedReferralsLevel2([uid]);
};

export const getUserReferralsLevel3 = (uid) => {
    if (!uid) {
        return (dispatch) => {
            dispatch({ type: 'FETCH_REFERRAL_LIST3_LOADING', payload: true });
            dispatch({ type: 'FETCH_REFERRAL_LIST_SUCCESS3', payload: [] });
        };
    }
    return getAggregatedReferralsLevel3([uid]);
};
